import { createAction } from "redux-act";

export const toggleSideMenu = createAction('toggle side menu');
export const toggleSideMenuHover = createAction<boolean>('toggle side menu hover');
export const toggleExecuteBillingModal = createAction<boolean>('toggle execute billing modal');
